import { assetsApiClient } from '@api/clients';
import { useQuery, UseQueryResult } from 'react-query';
import { Asset } from '@api/api';

export const fetchAssetsPrices = async (tickers: string[]): Promise<Asset[]> => {
  const { data } = await assetsApiClient.assetsGet({ tickers });

  return data;
};

export const useAssetsPrices = (tickers: string[], enabled = false): UseQueryResult<Asset[]> => {
  return useQuery(['assets-prices'], () => fetchAssetsPrices(tickers), { enabled });
};
